import { WEBSITES } from 'platform/adminPanel/websites/website.navigation';
import WebsiteList from 'platform/adminPanel/websites/WebsiteList';

const WEBSITE_ROUTE = { ...WEBSITES, component: WebsiteList };

export default WEBSITE_ROUTE;
